module.exports = __webpack_public_path__ + "static/media/Annie Stefanec Headshot.3d0cbc14.png";